module.exports = __webpack_public_path__ + "static/85-0ed512992c0a1b5c76539c4ab6036f9c.png";